import * as React from 'react';

import { PromoModalActions } from '../../components/PromoModalActions';
import { SendMessageButtonContainer } from '../AsideContacts/SendMessageButton';
import { PurchaseTermsCallButton } from '../PurchaseTermsContainer/PurchaseTermsCallButton';

interface IPromoModalActionsProps {
  modalType: 'prices_modal' | 'purchase_term_modal';
  onModalClose?: () => void;
}

export const PromoModalActionsContainer = ({ modalType, onModalClose }: IPromoModalActionsProps) => {
  return (
    <PromoModalActions>
      <SendMessageButtonContainer
        title="Чат с застройщиком"
        theme="fill_secondary"
        ariaLabel="Чат с застройщиком"
        noMarginTop
        placeType={modalType}
        onChatButtonClick={onModalClose}
        tabIndex={-1}
      />
      <PurchaseTermsCallButton modalType={modalType} />
    </PromoModalActions>
  );
};
